import type { Station } from '../api/types'
import { alertText, severity } from '../lib/health'

const ORDER = { alarm: 0, warning: 1, info: 2, stale: 3, normal: 4 }

/** A station's open alerts, as sentences, most severe first. A live region,
 *  so a screen reader hears one open while the page is open. The colour is
 *  the rule's; the words carry the meaning (DESIGN_GUIDELINE §2.6). */
export function StationAlerts({ station }: { station: Pick<Station, 'name' | 'alerts'> }) {
  const alerts = station.alerts ?? []
  if (!alerts.length) return null
  const sorted = [...alerts].sort((a, b) => ORDER[severity(a)] - ORDER[severity(b)])
  return (
    <div className="station-alerts" role="status" aria-live="polite">
      {sorted.map((alert) => {
        const { headline, detail } = alertText(station.name, alert)
        return (
          <div key={alert.id} className={`notice station-alert status-${severity(alert)}`}>
            <p className="station-alert-head">{headline}</p>
            <p className="muted">{detail}</p>
          </div>
        )
      })}
    </div>
  )
}
